import React from 'react';
import { ZfLoadingSpinner, ZfStack, ZfTypography } from '@zafire/react';
import { useTranslation } from 'react-i18next';
import { useGetContactNotes } from '../../../../hooks/queries/contactNotes';
import { LinkedContactNotesGrid } from '../../LinkedContactNotesGrid';

type ContactNotesBlockProps = {
  serviceAgreementId: string | undefined;
};

export const ContactNotesBlock: React.FC<ContactNotesBlockProps> = ({ serviceAgreementId }) => {
  const { t } = useTranslation();
  const { data, isLoading, isError } = useGetContactNotes(serviceAgreementId);

  if (isLoading) {
    return (
      <ZfStack
        data-testid="product-contact-notes-loading"
        direction="row"
        style={{ justifyContent: 'center', padding: '16px' }}
      >
        <ZfLoadingSpinner size="medium" />
      </ZfStack>
    );
  }

  if (isError) {
    return (
      <ZfTypography data-testid="product-contact-notes-error" variant="body-medium" color="danger">
        {t('pb.contactnotes.block.error', 'Contact notes could not be loaded.')}
      </ZfTypography>
    );
  }

  if (!data?.length) {
    return (
      <ZfTypography data-testid="product-contact-notes-empty" variant="body-medium">
        {t('pb.contactnotes.block.empty', 'No contact notes linked to this product.')}
      </ZfTypography>
    );
  }

  return <LinkedContactNotesGrid contactNotes={data} showActions={false} fitColumnsToWidth={false} />;
};
